export const ACTIONS = {
  JOIN_ROOM: 'join-room',
  LEAVE_ROOM: 'leave-room',
  MESSAGE_CREATE: 'message-create',
  MESSAGE_TYPING: 'message-typing',
  MESSAGE_RECEIVED_TYPING: 'message-received-typing',
  TOOGLE_ANYONE_TYPING: 'toogle-anyone-typing',
  MESSAGE_RECEIVED: 'message-received',
  DISCONNECT: 'disconnect',
  UPDATE: 'update',
};
